import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./Career.css";

export default function Career() {
  const mailId = "info@smartvizx.com";
  const subject = "Application for an opportunity at Trezi";

  const mailToLink = `mailto:${mailId}?subject=${encodeURIComponent(subject)}`;

  return (
    <>
      <Navbar />

      <main className="career-page">
        <div className="career-wrapper">
          <h1 className="career-title">
            Join Our Vision
          </h1>

          <p className="career-description">
            We are constantly seeking refined thinkers, designers, and
            technologists who believe in building meaningful digital worlds.
            If that resonates with you, we would love to connect.
          </p>

          <a href={mailToLink} className="send-mail-btn">
            Apply Now
          </a>

          <div className="career-links">
            <a
              href="https://www.linkedin.com/company/smartvizs-pvt-ltd-/"
              target="_blank"
              rel="noopener noreferrer"
            >
              View Open Roles
            </a>

            <a
              href="https://www.instagram.com/lifeattrezi/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Life at Trezi
            </a>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}